import { getLifecycle } from 'service/utils';

const REDUCER_NAME = 'SCORE_HISTORY' as const;

export const GET_EVOLUTIONS = getLifecycle(REDUCER_NAME, 'GET_EVOLUTIONS');

